import React, { ChangeEvent, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import {
    Coordinate,
    MapObject,
    PointOfInterest,
    Space,
    getMapData
} from '@mappedin/mappedin-js';
import { useDispatch } from 'react-redux';
import { clearLocationAmenities, createAmenities, deleteAmenity, getLocationAmenities, updateAmenity } from '../../../redux/location/actions/location.action';
import { useSelector } from 'react-redux';
import Loader from '../../common/loader/Loader';
import ClubHouse from '../../../images/amenities/theatre.svg';
import BusinessCenter from '../../../images/amenities/business.svg';
import Gym from '../../../images/amenities/GYM.svg';
import DogPark from '../../../images/amenities/Dog-Park.svg';
import EVChargingStation from '../../../images/amenities/Electric-Vehicle-Charging-Station.svg';
import LaundryRoom from '../../../images/amenities/Laundry-Room.svg';
import RentalSpace from '../../../images/amenities/Storage-Space-Rentals.svg';
import PackageLockers from '../../../images/amenities/Package-Locker.svg';
import Pool from '../../../images/amenities/Pool.svg';
import PetWashingCenter from '../../../images/amenities/Pet-Washing-Station.svg';
import PicnicArea from '../../../images/amenities/Picnic-Area.svg';
import PlayGround from '../../../images/amenities/Playground.svg';
import GardenIcon from '../../../images/amenities/Garden.svg';
import iconBack from '../../../images/icon-chevron-left.svg';
import BBQ from '../../../images/amenities/Picnic-Area.svg';

import styles from './AddEditAmenities.module.css';
import LocationIcon from '../../svgIcons/LocationIcon';
import UploadFileIcon from '../../svgIcons/UploadFileIcon';
import Toast from '../../common/toast/Toast';
import CloseIcon from '../../svgIcons/CloseIcon';
import { AxiosError } from 'axios';

import PineappleSorry from '../../../images/pineapple-juice.svg';
import { hasPermission } from '../../auth/login/Login';

export interface IconData {
    label: string;
    icon: string;
    media: (MediaFile | File)[] | null;
    center?: Coordinate;
    description?: null | string;
    websiteLinkTitle?: null | string;
    websiteLink?: null | string;
    id?: string | null;
}

export interface AmenitiesObj {
    name: string | null;
    latitude: number | null;
    longitude: number | null;
    mediaFiles: (MediaFile | File)[] | null;
    amenityWebLink: string | null;
    amenityWebLinkTitle: string | null;
    location: string | null;
    description: string | null;
}

export interface MediaFile {
    mimetype: "video/mp4" | "image/jpeg" | "image/png" | "video/mov";
    size?: number;
    url: string
}

export interface UpdateAmenityObject {
    name: string;
    latitude: string;
    longitude: string;
    newMediaFiles: (MediaFile | File)[];
    deletedMediaFiles: (MediaFile)[]
    existMediaFiles: (MediaFile)[]
    amenityWebLink: string;
    amenityWebLinkTitle: string;
    description: string;
    location: string;
}

export interface LocationProps {
    label: string;
    value: string;
    center?: Coordinate;
}

const MAX_FILE_SIZE = 15 * 1024 * 1024;
const ALLOWED_TYPES = ["image/jpeg", "image/png", "video/mp4", "video/quicktime"];

const extractMapId = (mapId: string) => {
    const pattern = /^https:\/\/app\.mappedin\.com\/map\/([^?/]+)(?:\?floor=.*)?$/;
    const match = mapId.match(pattern);
    return match ? match[1] : mapId;
};

const AddEditAmenities = () => {

    const permissionLoading = useSelector((state: IRootState) => state?.permissionsReducer?.loading);
    const canViewAmenities = hasPermission("Amenity", "Amenities", "read");
    const canUpdateAmenities = hasPermission("Amenity", "Amenities", "update");
    const canDeleteAmenities = hasPermission("Amenity", "Amenities", "delete");
    const canCreateAmenities = hasPermission("Amenity", "Amenities", "delete");
    const params = useParams();
    const dispatch: AppDispatch = useDispatch();
    const navigate = useNavigate();
    const { id: locationId } = params;

    const [selectedAmenities, setSelectedAmenities] = useState<IconData | null>(null);
    const [amenitiesList, setAmenitiesList] = useState<IconData[] | null>(null)
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState('');
    const [toastMessage, setToastMessage] = useState('');
    const { data: amenitiesData, errorMsg: ameniotiesError, loading: amenitiesLoading } = useSelector((state: IRootState) => state.locationReducer.amenities);
    const [isLoading, setIsLoading] = useState(false);

    const [mappedInError, setMappedInError] = useState(false);

    const icons: IconData[] = [
        { label: 'playground', icon: PlayGround, media: null },
        { label: 'clubhouse', icon: ClubHouse, media: null },
        { label: 'business center', icon: BusinessCenter, media: null },
        { label: 'gym', icon: Gym, media: null },
        { label: 'fitness center', icon: Gym, media: null },
        { label: 'dog park', icon: DogPark, media: null },
        { label: 'pet park', icon: DogPark, media: null },
        { label: 'electric vehicle charging station', icon: EVChargingStation, media: null },
        { label: 'laundry room', icon: LaundryRoom, media: null },
        { label: 'laundry', icon: LaundryRoom, media: null },
        { label: 'storage space rentals', icon: RentalSpace, media: null },
        { label: 'package locker', icon: PackageLockers, media: null },
        { label: 'pool', icon: Pool, media: null },
        { label: 'swimming pool', icon: Pool, media: null },
        { label: 'pet washing station', icon: PetWashingCenter, media: null },
        { label: 'picnic area', icon: PicnicArea, media: null },
        { label: 'garden', icon: GardenIcon, media: null },
        { label: 'grocery store', icon: BusinessCenter, media: null },
        { label: 'BBQ', icon: BBQ, media: null },
    ];

    const amenitiesIconData: IconData[] = [
        { label: 'Business Center', icon: BusinessCenter, media: null },
        { label: 'Clubhouse', icon: ClubHouse, media: null },
        { label: 'Gym', icon: Gym, media: null },
        { label: 'Pool', icon: Pool, media: null },
        { label: 'BBQ', icon: BBQ, media: null },
        { label: 'Playground', icon: PlayGround, media: null },
        { label: 'Dog Park', icon: DogPark, media: null },
        { label: 'Pet Washing', icon: PetWashingCenter, media: null },
        { label: 'Laundry', icon: LaundryRoom, media: null },
        { label: 'EV Charging', icon: EVChargingStation, media: null },
        { label: 'Package Locker', icon: PackageLockers, media: null },
        { label: 'Storage Space', icon: RentalSpace, media: null },
        { label: 'Garden', icon: GardenIcon, media: null },
    ]

    useEffect(() => {
        if (locationId) {
            dispatch(getLocationAmenities(locationId));
        }

        return () => {
            setSelectedAmenities(null);
            setAmenitiesList(null);
            dispatch(clearLocationAmenities());
        }
    }, []);

    const backNavigationHandler = () => {
        navigate('/amenities');
    };

    const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>, value: IconData) => {
        const files = event?.target?.files;

        if (files && Array.from(files).some(file => !ALLOWED_TYPES.includes(file.type) || file.size > MAX_FILE_SIZE)) {
            setShowToast(true);
            setToastMessage('Please select only valid files (JPEG, PNG, MP4, MOV) under 15MB');
            setToastType('error');
            return;
        }

        if (files) {
            const updatedAmenitiesObject: IconData = {
                ...value,
                media: value.media ? [...files, ...value.media].splice(0, 3) : [...files].splice(0, 3),
            };
            if (amenitiesList) {
                const updatedAmenitiesList = amenitiesList.map((item: IconData) =>
                    item.label === updatedAmenitiesObject.label ? updatedAmenitiesObject : item
                );
                setAmenitiesList(updatedAmenitiesList);
                setSelectedAmenities(updatedAmenitiesObject);
            }
        }
    };

    const removeMedia = (value: IconData, index: number) => {
        if (value?.media && value?.media?.length > 0) {
            const updatedMediaObject = [...value.media];
            updatedMediaObject.splice(index, 1);

            if (amenitiesList) {
                const updatedAmenitiesList = amenitiesList.map((item: IconData) =>
                    item.label === value.label ? {
                        ...value,
                        media: updatedMediaObject
                    } : item
                );
                setAmenitiesList(updatedAmenitiesList);
                setSelectedAmenities({ ...value, media: updatedMediaObject });
            }
        }
    }

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
            }, 4000);
        }
    }, [showToast]);

    const checkUpdatedAmenity = (amenities?: IconData[]) => {
        const amenityLabel = selectedAmenities?.label;

        if (amenityLabel && amenities) {
            const fetchUpdatedData = amenities?.find((value: IconData) => amenityLabel === value.label);
            if (fetchUpdatedData) {
                setSelectedAmenities(fetchUpdatedData);
            } else {
                setSelectedAmenities(amenities[0])
            }
        } else if (amenityLabel && !amenities && amenitiesList) {
            const fetchUpdatedData = amenitiesList?.find((value: IconData) => amenityLabel === value.label);
            if (fetchUpdatedData) {
                setSelectedAmenities(fetchUpdatedData);
            } else {
                setSelectedAmenities(amenitiesList[0])
            }
        } else {
            if (!amenityLabel && amenities) {
                setSelectedAmenities(amenities[0]);
            } else if (!amenities && amenitiesList) {
                setSelectedAmenities(amenitiesList[0]);
            }
        }

    }

    const getMapDetails = async () => {
        if (amenitiesData?.location?.mappedInId) {
            setIsLoading(true);
            try {
                const mapData = await getMapData({
                    key: import.meta.env.VITE_MAPPEDIN_KEY || "",
                    secret: import.meta.env.VITE_MAPPEDIN_SECRET || "",
                    mapId: extractMapId(amenitiesData?.location?.mappedInId),
                });


                if (mapData) {
                    const amenities: IconData[] = [];

                    if (mapData) {
                        const iconMap = new Map<string, IconData>(
                            icons.map(icon => [icon.label.toLowerCase(), icon])
                        );

                        mapData.getByType('object').forEach((value: MapObject) => {
                            if (value.name) {
                                const matchedIcon = iconMap.get(value.name.toLowerCase());
                                if (matchedIcon) {
                                    amenities.push({
                                        ...matchedIcon,
                                        center: value.center
                                    });
                                }

                            }
                        });

                        mapData?.getByType('point-of-interest').forEach((value: PointOfInterest) => {
                            if (value.name) {
                                const matchedIcon = iconMap.get(value.name.toLowerCase());
                                if (matchedIcon) {
                                    amenities.push({
                                        ...matchedIcon,
                                        center: value.coordinate
                                    });
                                }

                            }
                        });

                        mapData?.getByType('space').forEach((value: Space) => {
                            if (value.name) {
                                const matchedIcon = iconMap.get(value.name.toLowerCase());
                                if (matchedIcon) {
                                    amenities.push({
                                        ...matchedIcon,
                                        center: value.center
                                    });
                                }
                            }
                        });

                        await setAmenitiesList(amenities);
                        await getAmenities(amenities);
                        setIsLoading(false);
                    }
                } else {
                    console.error('error');
                    setMappedInError(true);
                    setToastMessage('Incorrect MappedIn details',);
                    setToastType('error');
                    setShowToast(true);
                }
            } catch (error) {
                setIsLoading(false)
                if (error instanceof AxiosError) {
                    console.error('Axios error:', error.response?.data);
                } else if (error instanceof Error) {
                    if (error.message.toString().trim() === '401') {
                        setToastMessage('Unauthorized MappedIn Id',);
                        setToastType('error');
                        setShowToast(true);
                        setMappedInError(true);
                    }
                } else {
                    console.error('Unexpected error:', error);
                }
            }
        }
    }

    const onNoMapIdFound = async () => {
        await setAmenitiesList(amenitiesIconData);
        await getAmenities(amenitiesIconData);
    }

    useEffect(() => {
        if (amenitiesData && amenitiesData?.location) {
            if (amenitiesData?.location?.mappedInId) {
                getMapDetails();
            } else {
                onNoMapIdFound();
            }
        }
    }, [amenitiesData]);

    const getAmenities = (amenities?: IconData[]) => {
        if (!amenities && amenitiesData && amenitiesData?.amenities && amenitiesList) {
            const updatedAmenityList = [...amenitiesList];
            if (amenitiesData?.amenities?.length > 0) {
                amenitiesData?.amenities.forEach((value: any) => {
                    const index = updatedAmenityList.findIndex((item: any) => item.label === value.name);
                    if (index !== -1) {
                        updatedAmenityList[index] = {
                            ...updatedAmenityList[index],
                            media: value.mediaFiles,
                            description: value.description || null,
                            websiteLinkTitle: value.websiteLinkTitle || null,
                            websiteLink: value.websiteLink || null
                        };
                    }
                });
            }
            setAmenitiesList(updatedAmenityList);
            checkUpdatedAmenity(updatedAmenityList);
        } else if (amenities && amenitiesData && amenitiesData?.amenities) {
            const updatedAmenityList = [...amenities];
            if (amenitiesData?.amenities?.length > 0) {
                amenitiesData?.amenities.forEach((value: any) => {
                    const index = updatedAmenityList.findIndex((item: any) => item.label === value.name);
                    if (index !== -1) {
                        updatedAmenityList[index] = {
                            ...updatedAmenityList[index],
                            id: value?.id,
                            media: value.mediaFiles,
                            description: value.description || null,
                            websiteLinkTitle: value.amenityWebLinkTitle || null,
                            websiteLink: value.amenityWebLink || null
                        };
                    }
                });
            }
            setAmenitiesList(updatedAmenityList);
            checkUpdatedAmenity(updatedAmenityList);
        }
    }

    const onDescriptionChangeEvent = (value: string, amenity: IconData) => {
        const updatedAmenitiesObject: IconData = {
            ...amenity,
            description: value?.trimStart()?.length > 0 ? value?.trimStart() : null
        };

        if (amenitiesList) {
            const updatedAmenitiesList = amenitiesList.map((item: IconData) =>
                item.label === updatedAmenitiesObject.label ? updatedAmenitiesObject : item
            );

            setAmenitiesList(updatedAmenitiesList);
            setSelectedAmenities(updatedAmenitiesObject);
        }
    }

    const onWebsiteLinkTitleChange = (value: string, amenity: IconData) => {
        const updatedAmenitiesObject: IconData = {
            ...amenity,
            websiteLinkTitle: value?.trimStart()?.length > 0 ? value?.trimStart() : null
        };

        if (amenitiesList) {
            const updatedAmenitiesList = amenitiesList.map((item: IconData) =>
                item.label === updatedAmenitiesObject.label ? updatedAmenitiesObject : item
            );

            setAmenitiesList(updatedAmenitiesList);
            setSelectedAmenities(updatedAmenitiesObject);
        }
    }

    const onWebsiteLinkChange = (value: string, amenity: IconData) => {
        const updatedAmenitiesObject: IconData = {
            ...amenity,
            websiteLink: value?.trimStart()?.length > 0 ? value?.trimStart() : null
        };

        if (amenitiesList) {
            const updatedAmenitiesList = amenitiesList.map((item: IconData) =>
                item.label === updatedAmenitiesObject.label ? updatedAmenitiesObject : item
            );

            setAmenitiesList(updatedAmenitiesList);
            setSelectedAmenities(updatedAmenitiesObject);
        }
    }

    const onSaveAndUpload = () => {
        if (locationId) {
            setIsLoading(true);

            if (selectedAmenities?.websiteLink && !isValidURL(selectedAmenities?.websiteLink)) {
                setToastMessage("Please Enter valid Website Link");
                setToastType('error');
                setShowToast(true);
                setIsLoading(false);
                return
            }

            const newAmenityObj: AmenitiesObj = {
                name: selectedAmenities?.label || null,
                latitude: selectedAmenities?.center?.latitude || null,
                longitude: selectedAmenities?.center?.longitude || null,
                mediaFiles: selectedAmenities?.media && Array.isArray(selectedAmenities?.media) && Array.from(selectedAmenities?.media)?.length > 0 ? selectedAmenities?.media : null,
                amenityWebLink: selectedAmenities?.websiteLink || null,
                amenityWebLinkTitle: selectedAmenities?.websiteLinkTitle || null,
                location: locationId || null,
                description: selectedAmenities?.description || null
            }
            dispatch(createAmenities(newAmenityObj, onCreateAmenitieSuccess, onCreateAmenitieFailure))
        }
    }

    const isDifferentImages = (oldImages: (File | MediaFile)[] | null, newImages: (File | MediaFile)[] | null) => {

        if (oldImages === null && newImages === null) {
            return false
        } else if (((oldImages === null && newImages !== null) || (oldImages !== null && newImages === null))) {
            return true;
        }
        else {
            if (!oldImages || !newImages) {
                return true;
            }

            if (oldImages.length !== newImages.length) {
                return true;
            }

            for (let i = 0; i < oldImages.length; i++) {
                const oldImage = oldImages[i];
                const newImage = newImages[i];

                if (typeof oldImage !== typeof newImage) {
                    return true;
                }

                if (JSON.stringify(oldImage) !== JSON.stringify(newImage)) {
                    return true;
                }
            }
        }
        return false
    };


    const getStandardValue = (value: string | null | undefined) => {
        if (value?.trim() === '' || value === null || value === undefined) {
            return null;
        } else {
            return value;
        }
    }

    const checkIsSame = (first: string | null | undefined, second: string | null | undefined) => {
        if (getStandardValue(first) === getStandardValue(second)) {
            return true;
        } else {
            return false;
        }
    }

    const isAnyMediaExist = () => {
        if (selectedAmenities) {
            const fetchedData =
                amenitiesData?.amenities &&
                amenitiesData?.amenities?.find(
                    (item: { name: string | null }) => item.name === selectedAmenities?.label
                );

            if (fetchedData) {
                if (
                    checkIsSame(selectedAmenities.description, fetchedData.description) &&
                    checkIsSame(selectedAmenities.websiteLink, fetchedData.amenityWebLink) &&
                    checkIsSame(selectedAmenities.websiteLinkTitle, fetchedData.amenityWebLinkTitle)
                ) {
                    if (
                        isDifferentImages(fetchedData.mediaFiles, selectedAmenities.media) &&
                        selectedAmenities.media?.length
                    ) {
                        return true;
                    }
                    if (isDifferentImages(fetchedData.mediaFiles, selectedAmenities.media) && !selectedAmenities.media?.length && (selectedAmenities?.description || (selectedAmenities?.websiteLinkTitle && selectedAmenities?.websiteLinkTitle))) {
                        return true;
                    }
                    return false;
                } else {
                    if (
                        (Array.isArray(selectedAmenities.media) && selectedAmenities.media.length > 0) ||
                        !!selectedAmenities?.description ||
                        (selectedAmenities?.websiteLinkTitle && selectedAmenities?.websiteLink)
                    ) {
                        if (
                            (selectedAmenities.websiteLink || selectedAmenities.websiteLinkTitle) &&
                            (!selectedAmenities.websiteLink ||
                                !selectedAmenities.websiteLinkTitle ||
                                (selectedAmenities.websiteLink &&
                                    !isValidURL(selectedAmenities.websiteLink)))
                        ) {
                            return false;
                        }
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                if (
                    (Array.isArray(selectedAmenities.media) && selectedAmenities.media.length > 0) ||
                    !!selectedAmenities?.description ||
                    (selectedAmenities?.websiteLinkTitle && selectedAmenities?.websiteLink)
                ) {
                    if (selectedAmenities?.websiteLink || selectedAmenities?.websiteLinkTitle) {
                        if (
                            selectedAmenities?.websiteLinkTitle &&
                            selectedAmenities?.websiteLink &&
                            isValidURL(selectedAmenities.websiteLink)
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
    };

    const isAnyChangesDone = () => {
        if (amenitiesData && amenitiesData?.amenities && amenitiesList) {
            if (amenitiesData?.amenities?.length > 0) {
                const fetchedData = amenitiesData?.amenities && amenitiesData?.amenities?.find((item: { name: string | null }) => item.name === selectedAmenities?.label);
                if (fetchedData && selectedAmenities) {
                    return true
                } else {
                    return false
                }
            }
        } else {
            return false
        }
    }

    const onCreateAmenitieSuccess = (successMessage: string) => {
        setIsLoading(false);
        updateAmenityData()
        setToastMessage(successMessage);
        setToastType('success');
        setShowToast(true);
    }

    const onCreateAmenitieFailure = (failureMessage: string) => {
        setIsLoading(false);
        setToastMessage(failureMessage || "something went wrong");
        setToastType('error');
        setShowToast(true);
    }

    const onUpdateSuccess = (successMessage: string) => {
        setIsLoading(false);
        updateAmenityData()
        setToastMessage(successMessage);
        setToastType('success');
        setShowToast(true);
    }


    const onUpdateFailure = (failureMessage: string) => {
        setIsLoading(false);
        setToastMessage(failureMessage || "something went wrong");
        setToastType('error');
        setShowToast(true);
    }

    const onUpdate = () => {
        if (selectedAmenities) {
            setIsLoading(true);
            const fetchedData = amenitiesData?.amenities && amenitiesData?.amenities?.find((item: { id: string | null }) => item.id === selectedAmenities?.id)

            const deletedFiles: (MediaFile)[] = [];
            const existingMedia: (MediaFile)[] = [];
            const newMedia: (MediaFile | File)[] = [];

            const fetchedMediaFiles = fetchedData?.mediaFiles || [];
            const selectedMediaFiles = selectedAmenities?.media || [];

            deletedFiles.push(
                ...fetchedMediaFiles.filter((file: File | MediaFile) => selectedMediaFiles && !selectedMediaFiles?.includes(file))
            );

            existingMedia.push(
                ...fetchedMediaFiles.filter((file: File | MediaFile) => selectedMediaFiles && selectedMediaFiles?.includes(file))
            );

            if (selectedMediaFiles && fetchedMediaFiles) {
                newMedia.push(...selectedMediaFiles.filter((file: File | MediaFile) => fetchedMediaFiles && !fetchedMediaFiles?.includes(file)));
            }

            if (selectedAmenities?.websiteLink && !isValidURL(selectedAmenities?.websiteLink)) {
                setToastMessage("Please Enter valid Website Link");
                setToastType('error');
                setShowToast(true);
                setIsLoading(false);
                return;
            }

            const updatedObject: UpdateAmenityObject = {
                name: selectedAmenities?.label,
                latitude: selectedAmenities?.center?.latitude.toString() || "",
                longitude: selectedAmenities?.center?.longitude.toString() || "",
                newMediaFiles: newMedia,
                deletedMediaFiles: deletedFiles,
                existMediaFiles: existingMedia,
                amenityWebLink: selectedAmenities?.websiteLink || "",
                amenityWebLinkTitle: selectedAmenities?.websiteLinkTitle || "",
                description: selectedAmenities?.description || "",
                location: locationId || ""
            }
            if (selectedAmenities?.id) {
                dispatch(updateAmenity(selectedAmenities?.id, updatedObject, onUpdateSuccess, onUpdateFailure))
            }
        }
    }

    const updateAmenityData = async () => {
        if (locationId) {
            await dispatch(getLocationAmenities(locationId));
        }
    }

    const onDeleteSucces = (successMessage: string) => {
        updateAmenityData()
        setToastMessage(successMessage);
        setToastType('success');
        setShowToast(true);
        setIsLoading(false);
    }

    const onDeleteFailure = (failureMessage: string) => {
        setToastMessage(failureMessage || "something went wrong");
        setToastType('error');
        setShowToast(true);
        setIsLoading(false);
    }

    const onDeleteAmenity = (amenity: IconData | null) => {
        if (amenity && amenity.id) {
            setIsLoading(true)
            dispatch(deleteAmenity(amenity.id, onDeleteSucces, onDeleteFailure))
        }
    }

    const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

    const isValidURL = (url: string): boolean => {
        return urlRegex.test(url);
    };

    return (
        <div className={styles.amenitiesPageWrapper}>
            {(amenitiesLoading || isLoading) && <Loader />}
            {!amenitiesLoading && <div className={styles.innerPageContainer}>
                <div className={styles.pageHeader}>
                    <div className={styles.leftContainer}>
                        <div onClick={backNavigationHandler} className={styles.backButton}>
                            <img src={iconBack} alt="back icon" />
                        </div>
                        <div className={styles.locationDetailWrapper}>
                            <p className={styles.locationName}>{amenitiesData?.location?.locationName}</p>
                            <div className={styles.address}>
                                <LocationIcon />
                                <p>{`${`${amenitiesData?.location?.street1},` || ''} ${`${amenitiesData?.location?.streetNumber},` || ''} ${`${amenitiesData?.location?.city},` || ''} ${`${amenitiesData?.location?.state},` || ''} ${`${amenitiesData?.location?.zip}` || ''} `}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {amenitiesList && amenitiesList?.length > 0 && <div className={styles.detailWrapper}>
                    <div className={`${styles.leftListingContainer} ${styles.scrollable} `}>
                        {amenitiesList?.map((value: IconData, index: number) => {
                            return <div className={`${styles.box} ${selectedAmenities?.label === value.label ? styles.active : ''} `} key={index} onClick={() => setSelectedAmenities(value)}>
                                <img src={value.icon} width={24} height={24} />
                                <span>{value.label}</span>
                            </div>
                        })}
                    </div>
                    <div className={`${styles.rightContainer} ${styles.scrollable} `}>
                        {selectedAmenities && <div className={styles.header}>
                            <img src={selectedAmenities?.icon} width={44} height={44} />
                            <p>{selectedAmenities.label}</p>
                        </div>}

                        {selectedAmenities &&
                            <div className={styles.dropZone}>
                                <input multiple type='file' onChange={(e: ChangeEvent<HTMLInputElement>) => onFileUpload(e, selectedAmenities)}
                                    accept={ALLOWED_TYPES.toString()} />
                                <UploadFileIcon />

                                <p className={styles.primaryText}>
                                    Drag and Drop file or{' '}
                                    <span>
                                        <u>Click to Upload</u>
                                    </span>
                                </p>
                                <p className={styles.primaryText}>Max file size: 15 MB | Supported formats: .jpeg, .png, .mp4, .mov | Max 3 files allowed</p>
                            </div>
                        }

                        {(selectedAmenities?.media !== null && (selectedAmenities && Array.isArray(selectedAmenities?.media) && Array.from(selectedAmenities.media)?.length > 0)) && (
                            <div className={styles.mediaContainer}>
                                {selectedAmenities.media.map((item: MediaFile | File, index: number) => (
                                    <div key={index} className={styles.mediaBox}>
                                        {item instanceof File ? item?.type?.startsWith("image/") ? (
                                            <img
                                                src={URL.createObjectURL(item)}
                                                alt={`Media ${index} `}
                                                className={styles.mediaPreview}
                                            />
                                        ) : item?.type?.startsWith("video/") ? (
                                            <video controls className={styles.mediaPreview}>
                                                <source src={URL.createObjectURL(item)} type={item.type} />
                                                Your browser does not support the video tag.
                                            </video>
                                        ) : (
                                            <p>Unsupported media type</p>
                                        ) :
                                            (item && item?.url) && (item?.mimetype === 'image/jpeg' || item?.mimetype === 'image/png') ?
                                                <img
                                                    src={item?.url}
                                                    alt={`Media ${index} `}
                                                    className={styles.mediaPreview}
                                                />
                                                : (item?.mimetype === 'video/mov' || item?.mimetype === 'video/mp4') ?
                                                    <video controls className={styles.mediaPreview}>
                                                        <source src={item?.url} type={item.mimetype} />
                                                        Your browser does not support the video tag.
                                                    </video>
                                                    :
                                                    <p>Unsupported media type</p>
                                        }

                                        <div className={styles.deleteBtn} onClick={() => removeMedia(selectedAmenities, index)}>
                                            <CloseIcon fill='#f5004a' />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}


                        {selectedAmenities && <div className={styles.textAreaWrapper}>
                            <div className={styles.inputWrapper}>
                                <label>Description</label>
                                <textarea
                                    maxLength={300}
                                    value={selectedAmenities?.description?.trimStart() || ''}
                                    cols={2}
                                    onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                                        if (selectedAmenities) {
                                            onDescriptionChangeEvent(event.target.value, selectedAmenities)
                                        }
                                    }}
                                />
                                <p className={styles.counter}>{`${selectedAmenities?.description?.length?.toString() || '0'}/300`}</p>
                            </div>

                            <div className={styles.inlineInputWrapper}>
                                <div className={styles.inputWithError}>
                                    <div className={styles.inputWrapper}>
                                        <label>Website Link Title</label>
                                        <input
                                            maxLength={50}
                                            value={selectedAmenities?.websiteLinkTitle?.trimStart() || ''}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                if (selectedAmenities) {
                                                    onWebsiteLinkTitleChange(event.target.value, selectedAmenities)
                                                }
                                            }}
                                        />
                                    </div>
                                    <p className={styles.counter}>{`${selectedAmenities?.websiteLinkTitle?.length?.toString() || '0'}/50`}</p>
                                </div>

                                <div className={styles.inputWithError}>
                                    <div className={styles.inputWrapper}>
                                        <label>Website Link</label>
                                        <input
                                            value={selectedAmenities?.websiteLink?.trimStart() || ''}
                                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                if (selectedAmenities) {
                                                    onWebsiteLinkChange(event.target.value, selectedAmenities)
                                                }
                                            }}
                                        />
                                    </div>
                                    {selectedAmenities?.websiteLink && !isValidURL(selectedAmenities?.websiteLink) && <p>Please enter valid URL.</p>}
                                </div>
                            </div>
                        </div>}

                        {selectedAmenities && <div className={styles.mediaUploader}>

                            {canDeleteAmenities && isAnyChangesDone() && <button className={styles.deletBtn} onClick={() => onDeleteAmenity(selectedAmenities)}>Delete</button>}
                            {isAnyChangesDone() ?
                                canUpdateAmenities && <button className={styles.blueBtn} disabled={!isAnyMediaExist()} onClick={onUpdate}>Update</button>
                                :
                                canCreateAmenities && <button className={styles.blueBtn} disabled={!isAnyMediaExist()} onClick={onSaveAndUpload}>Save & Upload</button>
                            }</div>}

                    </div>
                </div>}

                {!isLoading && (mappedInError || (amenitiesList?.length === 0 || !amenitiesList)) &&
                    <div className={styles.errorWrapper}>
                        <img src={PineappleSorry} alt='sorry' width={200} height={200} />
                        <p className={styles.primaryText}>
                            {mappedInError ?
                                'The provided MappedIn ID is either incorrect or unauthorized. ' :
                                `No amenities are associated with the provided MappedIn ID.`}
                        </p>
                    </div>
                }
            </div>
            }
            {showToast && <Toast type={toastType} message={toastMessage} />}
        </div >
    )
}

export default AddEditAmenities